module.exports = __webpack_public_path__ + "static/envelope-head-022c05be4e8c49d2133eaeb2636d9c1c.webp";